var exports = {
  "m": "search-input__pbqJij",
};

module.exports = exports;
